import { Box } from '@mui/material';
import Skeleton from '@mui/material/Skeleton';

const AllBusinessCardSkeleton = () => {
    // Create an array with four items to represent the four skeleton cards
    const skeletonCards = Array(4).fill(null);

    return (
        <Box sx={{ 
            width: "100%",
            display: "grid", 
            gridTemplateColumns: "repeat(4, 1fr)", 
            gap: "10px", 
            justifyItems: "left"
        }}>
            {skeletonCards.map((_, index) => (
                <Box key={index}>
                    <Box sx={{ pt: 0.5 }}>
                        <Skeleton />
                        <Skeleton width="60%" />
                    </Box>
                    <Skeleton variant="rectangular" width={280} height={200} />
                </Box>
            ))}
        </Box>
    );
}

export default AllBusinessCardSkeleton;
